<template>
  <section class="qrs-typography">
    <pageHeader class="mb--0" v-if="isapp">
      <h2 class="qrs-header-xl mt--0 mb--0">Medicines sick day guidance</h2>
    </pageHeader>

    <h1 v-if="!isapp" class="qrs-header-xl">Medicines sick day guidance</h1>

    <div class="section">
      <p>When you are unwell with any of the following:</p>
      <ul>
        <li>Vomiting or diarrhoea (unless only minor)</li>
        <li>Fevers, sweats and shaking (unless only minor)</li>
      </ul>
      <p>
        Then <strong>STOP</strong> taking the medicines highlighted in this
        guidance.
      </p>
      <p>
        Restart when you are well (after 24 - 48 hours of eating and drinking
        normally)
      </p>
      <p>If you are in any doubt, contact your pharmacist, doctor or nurse.</p>
    </div>

    <div class="mt--24" @click.stop.prevent="handleClick">
      <button
        v-if="!isapp"
        name="start"
        aria-label="start sick day guidance form"
        class="govuk-button mr--16"
        @click="$parent.goTo($GuidanceForm)"
      >
        Start
        <span class="screen-reader-text">start sick day guidance form</span>
      </button>
      <button
        v-if="isapp"
        name="start"
        aria-label="start sick day guidance form"
        class="govuk-button"
        @click="$parent.goTo($GuidanceForm)"
      >
        Start
        <span class="screen-reader-text">start sick day guidance form</span>
      </button>

      <!-- <a
        name="Print medicine sick day guidance card"
        aria-label="Print medicine sick day guidance card"
        class="govuk-button govuk-button--neutral mr--16"
        target="_blank"
        style="color: #333333"
        title="Access the form to complete offline"
        @click="printBlankPDF()"
      >
        <strong>Print this form</strong>
      </a> -->
      <a
        name="Download medicine sick day guidance card"
        aria-label="Download medicine sick day guidance card"
        class="govuk-button govuk-button--neutral"
        target="_blank"
        style="color: #333333"
        href="https://rightdecisions.scot.nhs.uk/media/1375/sickdayguidancepostcard-manual.pdf"
        title="Access the form to complete offline"
      >
        <strong>Download blank form</strong>
      </a>
    </div>
  </section>
</template>

<script>
// import blankPDF from '../../assets/SickDayGuidancePostCard_manual.pdf'

export default {
  name: "intro",

  data() {
    return {
      jsonData: this.$parent.jsonData,
      isapp: this.$parent.isapp,
      active: this.$parent.accordionActive,
      answeredItems: this.$parent.answeredItems,
      // blankPDF: blankPDF
    };
  },
  methods: {
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        let target = e.target.target == "_blank" ? "_blank" : "_self";
        let dataId = e.target.dataset.id == null ? -1 : e.target.dataset.id;
        console.log(dataId, "DATAID");
        var isnativeapp = document.getElementById("isnativeapp");
        if (isnativeapp === undefined || isnativeapp === null) {
          window.open(url, target);
          console.log("in web open");
        } else {
          let data = { title: "", nodeid: dataId, href: url, target: target };
          console.log("in app open");
          window.Native("dataCallback", data);
        }
      }
    },
    // printBlankPDF() {
    //   console.log("printing...");
    //   let pdfhtml = "https://tac-dhi-polypharmacy-dev-app.azurewebsites.net/media/1335/sickdayguidancepostcard-manual.pdf";
    //   let mywindow = window.open();
    //   mywindow.document.write(pdfhtml);
    //   // mywindow.print();
    //   // mywindow.close();
    // },
  },
};
</script>
